import { OfficialData } from "../../../networkRequest/officialsService";

export const formatVerifications = (officials: OfficialData[]) => {
  return officials.map((official: OfficialData) => {
    const sortedPostVerifications = [...official.post_verifications].sort(
      (a, b) => new Date(b.pending_at).getTime() - new Date(a.pending_at).getTime()
    );
    const sortedAgencyVerifications = [...official.agency_verifications].sort(
      (a, b) => new Date(b.pending_at).getTime() - new Date(a.pending_at).getTime()
    );
    return {
      ...official,
      post_verifications: sortedPostVerifications[0] || null,
      agency_verifications: sortedAgencyVerifications[0] || null
    };
  });
};